import React from "react";
import { Redirect, useParams } from "react-router-dom";

import WhatsAppApiConnections from "../WhatsAppApiConnections";
import FacebookInstagram from "../FacebookInstagram";

export default function ConfigApisChannel() {
  const { channel } = useParams();
  const key = String(channel || "").trim().toLowerCase();

  if (key === "whatsapp") {
    return <WhatsAppApiConnections />;
  }

  if (key === "facebook" || key === "instagram") {
    return <FacebookInstagram onlyPlatform={key} />;
  }

  return <Redirect to="/config-apis" />;
}

